import { IScheduleFrequency } from '../types/ISchedule';
import { Request } from './Request';

export const UpdateScheduleFrequencyServerSettingNames = {
  activeDirectorySyncScheduleFrequency: 'activeDirectorySyncScheduleFrequency',
  recommendationsTrainerScheduleFrequency: 'recommendationsTrainerScheduleFrequency'
};

export interface IUpdateScheduleFrequencyServerSettingParams {
  setting: string;
  value: IScheduleFrequency;
}

export interface IUpdateScheduleFrequencyServerSettingResult {
}

export class UpdateScheduleFrequencyServerSettingRequest extends Request<IUpdateScheduleFrequencyServerSettingParams, IUpdateScheduleFrequencyServerSettingResult> {
  constructor(params: IUpdateScheduleFrequencyServerSettingParams) {
    super('updateScheduleFrequencyServerSetting', params);
  }
}
